import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Tooltip } from 'react-tippy';
import { propArrayShape, propFunc, propOneOf, } from '../../../../helpers/custom-prop-types';
import HtmlLink from '../../../Ui/Common/HtmlLink';
import Image from '../../../Ui/Common/Image';
const ProfessionalUnitProjectCareerProfessionals = (props) => {
    const { professionals, showAlertModal, userMode } = props;
    const onClickLink = userMode !== 'view' ? showAlertModal : undefined;
    return (_jsx("ul", Object.assign({ className: 'project_career_professionals' }, { children: professionals.map((professional) => (_jsx("li", Object.assign({ className: 'professional_column' }, { children: _jsx(HtmlLink, Object.assign({ className: 'professional_link', isNoLinkComponent: onClickLink ? 'button' : undefined, onClick: onClickLink, target: '_blank', to: `/consultant/${professional.id}` }, { children: _jsx(Tooltip, Object.assign({ animation: 'scale', arrow: true, duration: 100, html: `${professional.lastName} ${professional.firstName}`, trigger: 'mouseenter' }, { children: _jsx(Image, { alt: '', className: 'thumbnail_image', isObjectFit: true, noImageType: 'user', src: professional.photo, useImage: true }) })) })) }), professional.id))) })));
};
ProfessionalUnitProjectCareerProfessionals.propTypes = {
    professionals: propArrayShape().isRequired,
    showAlertModal: propFunc(),
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
ProfessionalUnitProjectCareerProfessionals.defaultProps = {
    showAlertModal: undefined,
};
export default ProfessionalUnitProjectCareerProfessionals;
